import React from "react";
import Lottie from "react-lottie";
import { loaderSettings } from "../../views/calificacion/Styles";

export const Bouncing = () => {
  return <Lottie options={loaderSettings} width={400} />;
};
